module.exports = __webpack_public_path__ + "img/card_bg.47290fe5.svg";